const DEBUG = process.env.NODE_ENV === 'development';

export const log = {
  info: (message: string, ...args: any[]) => {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.log(message, ...args);
    }
  },
  warn: (message: string, ...args: any[]) => {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.warn(message, ...args);
    }
  },
  error: (message: string, ...args: any[]) => {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.error(message, ...args);
    }
  },
};

export function extractInitials(name: string) {
  const names = name.trim().split(' ');
  const firstName = names[0] ?? '';
  const lastName = names.length > 1 ? names[names.length - 1] : '';
  return firstName && lastName
    ? `${firstName.charAt(0)}${lastName.charAt(0)}`
    : firstName.charAt(0);
}

// To check if the repo is centrally owned (Managed by Xelerate),
// we can check if the location contains 'xelerate-external-assets' (case-insensitive)
export function isCentrallyOwnedRepo(location: string): boolean {
  return location.toLowerCase().includes('xelerate-external-assets');
}

export interface CentrallyOwnedRepoInfo {
  isCentrally: boolean;
  gitFolder: string | null; // e.g., 'entities/nithin.krishnan2@cognizant.com'
  owner: string | null; // e.g., 'nithin.krishnan2@cognizant.com'
}

// Extract git folder and owner info from centrally owned repo URL
// URL format: https://raw.githubusercontent.com/owner/xelerate-external-assets/branch/entities/owner-name/file.yaml
export function extractCentrallyOwnedRepoInfo(
  location: string,
): CentrallyOwnedRepoInfo {
  const isCentrally = isCentrallyOwnedRepo(location);

  if (!isCentrally) {
    return { isCentrally: false, gitFolder: null, owner: null };
  }

  try {
    const url = new URL(location);
    const pathParts = url.pathname.split('/').filter(p => p); // Remove empty parts

    // Find 'entities' folder index
    const entitiesIndex = pathParts.findIndex(p => p === 'entities');

    if (entitiesIndex !== -1 && entitiesIndex + 1 < pathParts.length) {
      const owner = pathParts[entitiesIndex + 1]; // Owner folder name (e.g., 'nithin.krishnan2@cognizant.com')
      const gitFolder = `entities/${owner}`; // Git folder path

      return {
        isCentrally: true,
        gitFolder,
        owner,
      };
    }
  } catch (e) {
    // URL parsing failed
  }

  return { isCentrally: true, gitFolder: null, owner: null };
}
